import {
  dimensiondata_1_tetelek_group_row,
  dimensiondata_2_termekek_group_column,
  year_column_expanded,
  month_column,
  petajoule_value_1_data_precision2_no_year_summary,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const haviPrimerEnergiaConfig: PivotGridConfig = {
  showChart: false,
  filterYear: { numberOfYears: 1},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/HaviPrimerEnergia',
      select: ['date', 'dimension_1', 'dimension_2', 'value_1'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      ...dimensiondata_1_tetelek_group_row,
      year_column_expanded,
      month_column,
      ...dimensiondata_2_termekek_group_column,
      petajoule_value_1_data_precision2_no_year_summary,
      order_1,
      order_2
    ],
  },
};
